
import React from "react";
import { Link } from "react-router-dom";
import { MenuIcon, PhoneIcon, MailIcon } from "lucide-react";

const NavbarTopSection = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <div className="bg-gray-100 shadow-sm">
      <div className="flex justify-between items-center py-4 px-4 md:px-8 xl:px-12">
        <Link to="/" className="flex items-center space-x-1">
          <img 
            src="/lovable-uploads/aab48b83-0dca-4d12-be84-9b60e3f0b2be.png" 
            alt="USA Traffic Control Logo" 
            className="h-16 w-auto"
          />
        </Link>
        <div className="flex items-center">
          <div className="hidden md:flex flex-col justify-center items-end mr-4">
            <span className="flex items-center text-[0.98rem] font-semibold text-black font-alatsi leading-tight mb-1">
              <MailIcon className="h-4 w-4 mr-2 text-black" />
              Hello@USATrafficControl.com
            </span>
            <span className="flex items-center text-[0.98rem] font-bold text-black font-alatsi leading-tight">
              <PhoneIcon className="h-4 w-4 mr-2 text-black" />
              720-298-9505
            </span>
          </div>
          <button
            className="md:hidden text-orange-500 hover:text-orange-600 transition-colors duration-200 ml-4"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <MenuIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavbarTopSection;
